var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.4183 6.17726C13.9423 6.08932 13.5051 6.39311 13.4145 6.85779C13.3238 7.32247 13.6286 7.77616 14.0917 7.8671C15.4859 8.13891 16.5625 9.21817 16.8354 10.6172V10.6182C16.9131 11.0209 17.2676 11.3137 17.6759 11.3137C17.7307 11.3137 17.7855 11.3087 17.8412 11.2987C18.3043 11.2058 18.6091 10.7531 18.5185 10.2874C18.1111 8.19787 16.5027 6.58398 14.4183 6.17726Z",
    fill: "#0B7077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.3561 2.69519C14.133 2.66321 13.9089 2.72916 13.7307 2.87106C13.5474 3.01497 13.4329 3.22282 13.408 3.45566C13.3552 3.92634 13.6948 4.35205 14.1649 4.40501C17.4065 4.76676 19.9262 7.29203 20.2907 10.5438C20.3395 10.9795 20.705 11.3083 21.1412 11.3083C21.174 11.3083 21.2059 11.3063 21.2388 11.3023C21.4668 11.2773 21.67 11.1644 21.8134 10.9845C21.9558 10.8046 22.0206 10.5808 21.9947 10.3519C21.5405 6.29471 18.4005 3.14588 14.3561 2.69519Z",
    fill: "#0B7077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0317 13.6596C15.0208 17.6476 15.9258 13.034 18.4656 15.5721C20.9143 18.02 22.3216 18.5105 19.2192 21.612C18.8306 21.9243 16.3616 25.6815 7.6846 17.0069C-0.993478 8.33126 2.76158 5.8597 3.07397 5.47121C6.18387 2.3611 6.66586 3.77664 9.11449 6.22458C11.6544 8.76375 7.04266 9.67167 11.0317 13.6596Z",
    fill: "#0B7077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.3e6099eb1ab045dafab019a1c0d5b962.svg";
export { ForwardRef as ReactComponent };